export default __webpack_public_path__ + "static/media/pencil.6348ab24.svg";